module.exports = __webpack_public_path__ + "img/46.3219a2cf.svg";